import moment from "moment";
import { minValidDate } from "../../DataEntry/Grid/gridFunctions";
import { parseRegisterFieldInfo } from "../utils";
import { patterns } from "../constants";


export const validateFormData = (values, field ,context) => {
  let errors = {};
 const {totalPages,jobData} = context;

    switch (field) {
      case "check_number":
        if (!values.check_number) {
          errors.check_number = "Required";
        }
        break;

        case "check_amount":
            // Required validation
            if (values.check_amount === "" || values.check_amount === undefined) {
                errors.check_amount = "Required";
            }
            // Zero amount validation with payment method constraints
            else if (values?.check_amount == parseFloat(0).toFixed(2) && values?.payment_method != "NON") {
                errors.check_amount = "Invalid Selection";
                errors.payment_method = "Invalid Selection";
            }
            // Positive amount validation with payment method constraints
            else if (parseFloat(values?.check_amount).toFixed(2) > parseFloat(0).toFixed(2) && 
                    values?.payment_method != "CHK" && 
                    values?.payment_method != "ACH" && 
                    values?.payment_method != "VCP") {
                errors.check_amount = "Invalid Selection";
                errors.payment_method = "Invalid Selection";
            }
            // Negative value validation
            else if (values.check_amount < 0) {
                errors.check_amount = "negative value";
            }
            
            break;

      case "check_date":
        // Check date validation (if this belongs in the check_amount case)
        if (values.check_date?.replace("__/__/____", "") == "") {
            errors.check_date = "Required";
        }
        else if (values.check_date?.replace("__/__/____", "") != "" && 
                (!moment(values.check_date, "MM/DD/YYYY", true).isValid() || 
                !moment(values.check_date, "MM/DD/YYYY", true).isAfter(minValidDate))) {
            errors.check_date = "Invalid date";
        }
        break;

      case "aba_routing_number":
        // if (!values.aba_routing_number) {
        //   errors.aba_routing_number = "Required";
        // }

        if (
          jobData?.client_level_customization?.is_aba_routing_number &&
          values?.aba_routing_number === "" &&
          (values?.payment_method === "CHK" || values?.payment_method === "")
        ) {
          errors.aba_routing_number = "Invalid Selection";
        }

        if (
          jobData?.client_level_customization?.is_aba_routing_number &&
          values?.aba_routing_number !== "" &&
          values?.payment_method !== "CHK"
        ) {
          errors.aba_routing_number = "Invalid Selection";
        }
        break;

      case "payer_account_number":
        // if (!values.payer_account_number) {
        //   errors.payer_account_number = "Required";
        // }

        if (
          jobData?.client_level_customization?.is_payer_account_number &&
          values?.payer_account_number === "" &&
          (values?.payment_method === "CHK" || values?.payment_method === "")
        ) {
          errors.payer_account_number = "Invalid Selection";
        }

        if (
          jobData?.client_level_customization?.is_payer_account_number &&
          values?.payer_account_number !== "" &&
          values?.payment_method !== "CHK"
        ) {
          errors.payer_account_number = "Invalid Selection";
        }
        break;
      case "remaining_balance":
        if (!values.remaining_balance || values.remaining_balance !== parseFloat(0).toFixed(2)) {
          errors.remaining_balance = "Required";
        }
        break;


      case "payer_page_from":
      case "payer_page_to":
        if (
          (jobData?.client_level_customization?.is_payer_page_from_to&&totalPages > 0) &&
          (!values?.payer_page_from ||
            !values?.payer_page_to ||
            values?.payer_page_from <= 0 ||
            values?.payer_page_to <= 0 ||
            values?.payer_page_from > totalPages ||
            values?.payer_page_to > totalPages ||
            parseInt(values?.payer_page_from) > parseInt(values?.payer_page_to))
        ) {
          errors.payer_page_from = "Invalid Page Number";
          errors.payer_page_to = "Invalid Page Number";
        }
        break;

      case "payee_page_from":
      case "payee_page_to":
        if (
          (jobData?.client_level_customization?.is_payee_page_from_to&&totalPages > 0) &&
          (!values?.payee_page_from ||
            !values?.payee_page_to ||
            values?.payee_page_from <= 0 ||
            values?.payee_page_to <= 0 ||
            values?.payee_page_from > totalPages ||
            values?.payee_page_to > totalPages ||
            parseInt(values?.payee_page_from) > parseInt(values?.payee_page_to))
        ) {
          errors.payee_page_from = "Invalid Page Number";
          errors.payee_page_to = "Invalid Page Number";
        }
        break;
        case "overall_page_from":
            const result = validateOverallPageFrom(values.overall_page_from, values, context);
            if (result) {
                errors.overall_page_from = result
            };
        break;
        case "overall_page_to":
            const result1 = validateOverallPageTo(values.overall_page_to, values, context);
            if (result1) {
                errors.overall_page_to = result1
            };
        break;
      default:
        break;
    }
    
    return errors;
};

// Validation functions
export const validateOverallPageFrom = (value, formData, context) => {
  if (formData.qdx_status === "INCOMPLETE") return null;
  
  const { totalPages,jobData } = context || {};
  if(!jobData?.client_level_customization?.overall_page_from){return null }
  const { overall_page_to } = formData || {};
  
  if (!value || value <= 0) {
    return "Invalid Page Number";
  }
  
  if (totalPages && value > totalPages) {
    return "Invalid Page Number";
  }
  
  if (overall_page_to && parseInt(value) > parseInt(overall_page_to)) {
    return "Invalid Page Number";
  }
  
  return null;
};

export const validateOverallPageTo = (value, formData, context) => {
  if (formData.qdx_status === "INCOMPLETE") return null;
  const { jobData,totalPages } = context || {};
  if(!jobData?.client_level_customization?.overall_page_to){return null }
  const { overall_page_from } = formData || {};
  
  if (!value || value <= 0) {
    return "Invalid Page Number";
  }
  
  if (totalPages && value > totalPages) {
    return "Invalid Page Number";
  }
  
  if (overall_page_from && parseInt(overall_page_from) > parseInt(value)) {
    return "Invalid Page Number";
  }
  
  return null;
};
export const validateLiteClaim = (claim,field ,context) => {
  const { totalPages } = context;
  let errors = {};


  switch (field) {
    case "patient_account_number":
      if (!claim.patient_account_number) {
        errors.patient_account_number = "Required";
      }
      break;

    case "page_from":
    case "page_to":
      if (
        totalPages > 0 &&
        (!claim.page_from ||
          !claim.page_to ||
          claim.page_from <= 0 ||
          claim.page_to <= 0 ||
          claim.page_from > totalPages ||
          claim.page_to > totalPages ||
          parseInt(claim.page_from) > parseInt(claim.page_to))
      ) {
        errors.page_from = "Invalid Page Number";
        errors.page_to = "Invalid Page Number";
      }
      break;

    default:
      break;

  };

  // Validate service lines


  return Object.keys(errors).length > 0 ? errors : null;
};

export const validatePlb = (plbData, field, context) => {
  const { formData } = context;
  let errors = {};

  // Skip validation if status is INCOMPLETE
  if (formData?.qdx_status === "INCOMPLETE") {
    return null;
  }

  switch (field) {
    case "reason":
      if (!plbData.reason) {
        errors.reason = "Select a valid option";
      }
      break;

    case "plb_amt":
      if (
        !plbData.plb_amt ||
        plbData.plb_amt === "" ||
        plbData.plb_amt === null ||
        parseFloat(plbData.plb_amt).toFixed(2) === parseFloat(0).toFixed(2)
      ) {
        errors.plb_amt = "Select a valid option";
      } else if (!patterns.amount.test(plbData.plb_amt)) {
        errors.plb_amt = "Must be a valid amount";
      }
      break;

    case "npi":
      if (!plbData.npi) {
        errors.npi = "Required";
      } else if (plbData.npi !== "" && !patterns.npi.test(plbData.npi)) {
        errors.npi = "Must be only digits";
      }
      break;

    default:
      break;
  }

  return Object.keys(errors).length > 0 ? errors : null;
};



export const validateLiteServiceLine = (line,field, context) => {
  let errors = {};

  
    switch (field) {
      case "billed":
        if (!line.billed) {
          errors.billed = "Required";
        }
        break;

      case "paid":
        if (!line.paid) {
          errors.paid = "Required";
        }
        break;

      case "period_start": {

        if (!line.period_start) {
          errors.period_start = "Required";
        } else {
          const date = moment(line.period_start, "MM/DD/YYYY", true);

          if (!date.isValid() || !date.isSameOrAfter(minValidDate)) {
            errors.period_start = "Invalid date";
          }
        }
        break;
      }
      case "period_end":
        if (!line.period_end) {
          errors.period_end = "Required";
        } else if (
          !moment(line.period_end, "MM/DD/YYYY", true).isValid() ||
        !moment(line.period_end, "MM/DD/YYYY", true).isSameOrAfter(moment(line.period_start, "MM/DD/YYYY", true)) ||
          !moment(line.period_end, "MM/DD/YYYY", true).isSameOrAfter(
            moment(line.period_start, "MM/DD/YYYY", true)
          )
        ) {
          errors.period_end = "Invalid date";
        }
        break;

      default:
        break;
    }
 

  return Object.keys(errors).length > 0 ? errors : null;
};







export const validateSingleField835Lte = (fieldPaths, values,setError, clearErrors, context) => {
  
  
  if (!Array.isArray(fieldPaths) || fieldPaths.length === 0) return;

  // Clear old errors first
 
  fieldPaths.forEach((fieldPath) => {
    let errorMessage = null;

    // Top-level fields
    if (["check_number", "check_amount", "check_date", "aba_routing_number",'payer_account_number','remaining_balance','payer_page_to','payer_page_from','overall_page_to','overall_page_from'].includes(fieldPath)) {
      const errors = validateFormData(values, fieldPath, context);
      errorMessage = errors[fieldPath] || null;
    }

    // Claim-level fields
    const {plbIndex,claimIndex,serviceLineIndex:lineIndex,fieldName} = parseRegisterFieldInfo(fieldPath)
    // Service-line-level fields
    if (lineIndex !== undefined && lineIndex !== null) {
      const lineErrors = validateLiteServiceLine(
        values.claims[claimIndex].service_lines[lineIndex],
        fieldName,
        context
      );
      errorMessage = lineErrors ? lineErrors[fieldName] || null : null;
    }else if (claimIndex !== undefined && claimIndex !== null) {
      const claimErrors = validateLiteClaim(values.claims[claimIndex], fieldName, context);
      errorMessage = claimErrors ? claimErrors[fieldName] || null : null;
    }else if (plbIndex !== undefined && plbIndex !== null) {
      const claimErrors = validatePlb(values.plb_adjustments[plbIndex], fieldName, context);
      errorMessage = claimErrors ? claimErrors[fieldName] || null : null;
    }



    // Set error into RHF if exists
    if (errorMessage) {
      setError(fieldPath, { type: "custom", message: errorMessage });
    }else{
       clearErrors(fieldPath);

    }

  });
};


export const validateAllFields835Lte = (values, context) => {
  let errors = {};
  if (values.qdx_status === "INCOMPLETE") return null;
  // Top-level fields
  ["overall_page_from","overall_page_to","check_number", "check_amount", "check_date", "aba_routing_number",'payer_account_number','remaining_balance','payer_page_to','payer_page_from'].forEach(
    (field) => {
      const fieldErrors = validateFormData(values, field, context);
      if (fieldErrors && Object.keys(fieldErrors).length > 0) {
        errors = { ...errors, ...fieldErrors };
      }
    }
  );

  // Claims
  if (values.claims && Array.isArray(values.claims)) {
    errors.claims = values.claims.map((claim) => {
      let claimErrorObj = {};

      // Claim-level fields
      ["patient_account_number", "page_from", "page_to"].forEach((field) => {
        const claimFieldErrors = validateLiteClaim(claim, field, context);
        if (claimFieldErrors) {
          claimErrorObj = { ...claimErrorObj, ...claimFieldErrors };
        }
      });

      // Service lines
      let serviceLineErrors = [];
      if (claim.service_lines && Array.isArray(claim.service_lines)) {
        serviceLineErrors = claim.service_lines.map((line) => {
          let lineErrorObj = {};
          ["billed", "paid", "period_start", "period_end"].forEach((field) => {
            const lineFieldErrors = validateLiteServiceLine(line, field, context);
            if (lineFieldErrors) {
              lineErrorObj = { ...lineErrorObj, ...lineFieldErrors };
            }
          });
          return lineErrorObj;
        });
      }

      return { ...claimErrorObj, service_lines: serviceLineErrors };
    });
  }

  // Remove empty error objects
  const cleanErrors = JSON.parse(
    JSON.stringify(errors, (key, value) =>
      value && typeof value === "object" && Object.keys(value).length === 0
        ? undefined
        : value
    )
  );

  return Object.keys(cleanErrors).length > 0 ? cleanErrors : null;
}



export const setRHFErrors = (errors, eobSetError, parentPath = "") => {
  if (!errors) return;

  Object.keys(errors).forEach((key) => {
    const value = errors[key];
    const path = parentPath ? `${parentPath}.${key}` : key;

    if (Array.isArray(value)) {
      // If it's an array, iterate with index
      value.forEach((item, index) => {
        setRHFErrors(item, eobSetError, `${path}[${index}]`);
      });
    } else if (typeof value === "object" && value !== null) {
      // Nested object
      setRHFErrors(value, eobSetError, path);
    } else {
      // Primitive value => actual error message
      eobSetError(path, { type: "custom", message: value });
    }
  });
}

